"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRaf = void 0;

var React = __importStar(require("react"));

var use_safe_layout_effect_1 = require("./use-safe-layout-effect");

function useRaf(ms, delay) {
  if (ms === void 0) {
    ms = 1e12;
  }

  if (delay === void 0) {
    delay = 0;
  }

  var _a = React.useState(0),
      elapsedTime = _a[0],
      setElapsedTime = _a[1];

  use_safe_layout_effect_1.useSafeLayoutEffect(function () {
    var raf, timerStop, start;

    var onFrame = function onFrame() {
      var time = Math.min(1, (Date.now() - start) / ms);
      setElapsedTime(time);
      loop();
    };

    var loop = function loop() {
      raf = requestAnimationFrame(onFrame);
    };

    var onStart = function onStart() {
      timerStop = setTimeout(function () {
        cancelAnimationFrame(raf);
        setElapsedTime(1);
      }, ms);
      start = Date.now();
    };

    var timerDelay = setTimeout(onStart, delay);
    return function cleanup() {
      clearTimeout(timerStop);
      clearTimeout(timerDelay);
      cancelAnimationFrame(raf);
    };
  }, [ms, delay]);
  return elapsedTime;
}

exports.useRaf = useRaf;